import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import Step from '@material-ui/core/Step';
import Stepper from '@material-ui/core/Stepper';
import StepLabel from '@material-ui/core/StepLabel';
import RegisterCompanyForm from './RegisterCompanyForm';
import RegisterCompanyContactForm, { RegisterContactPersonModel } from './RegisterCompanyContactForm';
import { RegisterCompanyModel } from './RegisterCompanyModels';
import * as RegisterCompanyStore from './registerCompanyStore';
import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import RegistrationCompleted from '../user/RegistrationCompleted';
import { localizations } from '../../localization/localization';

interface RegisterCompanyViewState {
    currentStep: number;
}

interface StepInfo {
    index: number;
    label: string;
}

const registerSteps: StepInfo[] = [
    {
        index: 0,
        label: localizations.units.companyDetailsHeader
    },
    {
        index: 1,
        label: localizations.units.contactPersonDetailsHeader
    }
]

const CompanyRegistrationSuccessful = ({ onContinue }: any) => {
    return <RegistrationCompleted
        title={localizations.register.thanksForRegistering}
        information={localizations.register.companyRegisterSuccessful}
        onContinue={onContinue}
        continueButtonLabel={localizations.register.continueToFrontPage} />
}

interface CompanyData {
    company: RegisterCompanyModel,
    contact: RegisterContactPersonModel
}

type RegisterCompanyViewProps = typeof RegisterCompanyStore.actionCreators & RegisterCompanyStore.RegisterCompanyState

class RegisterCompanyView extends React.Component<RegisterCompanyViewProps, RegisterCompanyViewState> {
    constructor(props: any) {
        super(props)

        this.state = {
            currentStep: 0
        }

        this.handleCompanySubmit = this.handleCompanySubmit.bind(this);
        this.setNextStep = this.setNextStep.bind(this);
        this.setPreviousStep = this.setPreviousStep.bind(this);
    }

    public render() {
        const { currentStep } = this.state;

        const { success } = this.props;

        return (
            success ? <CompanyRegistrationSuccessful onContinue={this.props.registerSuccessContinue} /> :
                <div className="loginContent">
                    <Typography variant="h3">{localizations.register.registerCompanyTitle}</Typography>
                    <Stepper nonLinear={false} activeStep={currentStep}>
                        {registerSteps.map((value) =>
                            <Step key={value.index}>
                                <StepLabel>{value.label}</StepLabel>
                            </Step>)}
                    </Stepper>
                    <div>
                        {this.getStepContent(currentStep)}
                    </div>
                </div >
        );
    }

    private getStepContent(stepIndex: number) {
        switch (stepIndex) {
            case 0:
                return <RegisterCompanyForm onSubmit={this.setNextStep} />;
            case 1:
                return <RegisterCompanyContactForm onSubmit={this.props.registerSubmit} onPreviousClick={this.setPreviousStep} />
        }

        return null;
    }

    private handleCompanySubmit() {
        this.setNextStep();
    }

    private setNextStep() {
        if (this.state.currentStep < registerSteps.length) {
            this.setState((prevState, props) => {
                return {
                    currentStep: prevState.currentStep + 1
                };
            });
        }
    }

    private setPreviousStep() {
        if (this.state.currentStep > 0) {
            this.setState((prevState, props) => {
                return {
                    currentStep: prevState.currentStep - 1
                };
            });
        }
    }
}

const mapStateToProps = (state: ApplicationState) => state.registerCompany;

export default connect(mapStateToProps, RegisterCompanyStore.actionCreators)(RegisterCompanyView);


// WEBPACK FOOTER //
// ./src/register/company/RegisterCompanyView.tsx